/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdresseResource } from '../models/AdresseResource';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AdresseService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Lister toutes les adresses
     * Sans filtre ni pagination : potentiellement volumineux.
     * @returns AdresseResource Array of `AdresseResource`
     * @throws ApiError
     */
    public adresseIndex(): CancelablePromise<Array<AdresseResource>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/adresse',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
    /**
     * Creer une adresse
     * `CODE_POSTAL`, `VILLE`, `PAYS` et `ADRESSE_COMPLETE` obligatoires ; `TELEPHONE` et `CODE_ACCES` optionnels. L'adresse se rattache ensuite a un client ou un projet par leur propre endpoint.
     * @param requestBody
     * @returns AdresseResource `AdresseResource`
     * @throws ApiError
     */
    public adresseStore(
        requestBody: {
            CODE_POSTAL: string;
            VILLE: string;
            PAYS: string;
            ADRESSE_COMPLETE: string;
            TELEPHONE?: string;
            CODE_ACCES?: string;
        },
    ): CancelablePromise<AdresseResource> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/adresse',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Detail d'une adresse
     * 404 si elle n'existe pas.
     * @param id
     * @returns AdresseResource `AdresseResource`
     * @throws ApiError
     */
    public adresseShow(
        id: string,
    ): CancelablePromise<AdresseResource> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/adresse/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
    /**
     * Modifier une adresse
     * Mise a jour partielle. 404 si elle n'existe pas.
     * @param id
     * @param requestBody
     * @returns AdresseResource `AdresseResource`
     * @throws ApiError
     */
    public adresseUpdate(
        id: string,
        requestBody?: {
            CODE_POSTAL?: string;
            VILLE?: string;
            PAYS?: string;
            ADRESSE_COMPLETE?: string;
            TELEPHONE?: string;
            CODE_ACCES?: string;
        },
    ): CancelablePromise<AdresseResource> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/adresse/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Supprimer une adresse
     * Renvoie l'adresse supprimee ; 404 si elle n'existe pas.
     * @param id
     * @returns AdresseResource `AdresseResource`
     * @throws ApiError
     */
    public adresseDestroy(
        id: string,
    ): CancelablePromise<AdresseResource> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/adresse/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
}
